export default __webpack_public_path__ + "static/media/congres-des-notaires.a57a9908.png";